 // Header Logo
  const header_logo = document.getElementsByClassName("header__logo")[0];
  const scrollHeight = 300;
  var videoHero = document.getElementsByClassName('video-hero');

window.addEventListener("scroll", function(event) {
    var top = this.scrollY;
  
    if (videoHero.length > 0) {
      if (top > scrollHeight) {
        header_logo.style.display = "flex";
      }
      else {
        header_logo.style.display = "none";
      }
    }
    else {
      header_logo.style.display = "flex";
    }
});

window.addEventListener('load', function () {
  if (videoHero.length > 0) {
    // videoHero exists
  }
  else {
    header_logo.style.display = "flex";
  }
}); 

// Filter Button Selected
var filterButton = document.getElementsByClassName('filter-button');

for (var i = 0; i < filterButton.length; i++) {
    filterButton[i].addEventListener('click', filterSelected);
}



function filterSelected(event) {
  console.log("1");
  if(event.target.classList.contains("selected")) {
      event.target.classList.remove("selected");
  }
  else {
     event.target.classList.add("selected");
  }

}



//